import { Typography } from "antd";
import styled from "styled-components";

export const StyledFormSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 22px;
  padding-bottom: 8px;
`;
StyledFormSection.displayName = "StyledFormSection";

export const StyledTitle = styled(Typography.Title)`
  && {
    margin: 0;
    font-weight: normal;
  }
`;
StyledTitle.displayName = "StyledTitle";

export const StyledModalTitle = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;

  & > span {
    translate: 0 -1px;
  }
`;
StyledModalTitle.displayName = "StyledModalTitle";

export const StyledTipsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;

  & > div {
    width: 100%;
  }

  &:has(> div + div) > div {
    width: calc(50% - 10px);
  }
`;
StyledTipsGrid.displayName = "StyledTipsGrid";

export const StyledTip = styled.div`
  & > span {
    display: block;
  }
  margin-bottom: 8px;
`;
StyledTip.displayName = "StyledTip";

export const StyledDescription = styled(Typography.Text)`
  font-weight: 500;
`;
StyledDescription.displayName = "StyledDescription";
